import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import FilterBar from "../../Components/UI/filterbar";
import DataTable from "../../Components/UI/table/DataTable";
import TableActions from "../../Components/UI/table/TableActions";
import StatusBadge from "../../Components/UI/statusBadge";
import AddEmployeeModal from "../../Components/stores/vendorStore";
import { deleteVendors, getVendors, updateVendors } from "../../MyApi/vendors";
import i18next from "i18next";

const VendorsTab = ({ currentPage, setCurrentPage, filters, setFilters }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState(null);
 const lang = i18next.language
  const {
    data: vendorsData,
    isLoading: vendorsLoading,
    isFetching: vendorsFetching,
    refetch: vendorsRefetch,
  } = useQuery(
    ["vendors", currentPage, filters],
    () => {
      return getVendors("", currentPage, filters);
    },
    {
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
    },
  );

  const listData = vendorsData?.data?.vendors || [];
  const totalItems = vendorsData?.data?.pagination?.total || 0;
  const lastPage = vendorsData?.data?.pagination?.last_page || 0;

  const vendorColumns = [
    { label: "الاسم الكامل", accessor: "full_name" },
    { label: "المتجر", accessor: "store_name" },
    {
      label: "الدور",
      render: (row) => <div className="text-green"> {row.role}</div>,
    },
    { label: "الفرع", accessor: "store_address" },
    { label: "الإيميل", accessor: "email" },
    {
      label: "رقم الجوال",
      render: (row) => (
        <div>
          {" "}
          {row.phone} <span className="text-green">({row.phone_code}) </span>
        </div>
      ),
    },
    { label: "تاريخ اخر تسجيل", accessor: "last_login" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          deleteFn={deleteVendors}
          id={row.id}  
          mutationKey={"deleteVendors"}
          edit={() => openModal("edit", row.id)}
          deletePermission={"delete_vendor"}
          viewPermission={"view_vendor"}
          editPermission={"update_vendor"}
          queryKey={"vendors"}
          is_active={row.is_active}
          togglePermission={"update_vendor"}
           toggleMutationKey="toggleActiveVendor"
        
        toggleFn={(id, status) =>
          updateVendors({ is_active: status, _method: "PUT" ,lang}, id)
        }
        />
      ),
    },
  ];

  const openModal = (mode, id) => {
    setModalMode(mode);
    setIsModalOpen(true);
    setModalId(id);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalId(null);
  };

  const filtersConfig = {
    search: "search",
    is_active: "is_active",
    date: "date",
    store: "store",
  };

  return (
    <>
      <FilterBar
        setFilters={setFilters}
        filters={filters}
        filtersConfig={filtersConfig}
      />
      <DataTable
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalItems={totalItems}
        itemsPerPage={lastPage}
        onAddClick={() => openModal("add")}
        columns={vendorColumns}
        data={listData}
        title="أصحاب المتاجر والموظفين"
        actionLabel="إضافة موظف"
        isLoading={vendorsLoading}
   
        isFetching={vendorsFetching}
        createPermission="create_vendor"
      />
      {isModalOpen && (
        <AddEmployeeModal
          show={isModalOpen}
          onClose={closeModal}
          refetch={vendorsRefetch}
          modalMode={modalMode}
          id={modalId}
        />
      )}
    </>
  );
};

export default VendorsTab;
